
import { default as LoadingIcon } from './LoadingIcon';

const Index = () => {
    return <div className='text-center mt-2' style={{ position: 'relative' }}><LoadingIcon /></div>

}

export default Index